import { render } from "./Footer.vue?vue&type=template&id=1c7ec12a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "@/styles/footer.css?vue&type=style&index=0&id=1c7ec12a&scoped=true&lang=css"
import "@/styles/common.css?vue&type=style&index=1&id=1c7ec12a&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7ec12a"]])

export default __exports__